import { PROD_URL } from "api/config";

const URL_AUTH_LOGOUT = PROD_URL + "/logout";

export { URL_AUTH_LOGOUT };
